import type { DOMOutputSpec } from 'prosemirror-model';
import { parseHTML, VNode } from 'zeed-dom';

const defaultSpec: DOMOutputSpec = ['p', {}, ''];

/**
 * Convert an HTML string into ProseMirror's DOMOutputSpec,
 * but always wrap result in an Array for destructuring.
 */
export function htmlToDOMOutputSpec(html?: string | null) {
  if (html == null || html === '') {
    return [defaultSpec] as DOMOutputSpec[];
  }

  const collection = parseHTML(html).childNodes;

  /**
   * Converts an array of nodes to a structured output.
   *
   * @param nodes - The array of nodes to convert.
   * @returns The structured output representing the converted nodes.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const convert = (nodes: any[]) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const output: any[] = [];

    if (nodes.length === 0) {
      return output;
    }

    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
      // node.normalize();

      if (node.nodeType === VNode.TEXT_NODE) {
        output.push(node.textContent);
      } else if (node.nodeType === VNode.ELEMENT_NODE) {
        const attributes = Array.from((node as Element).attributes).reduce(
          (acc, attr) => {
            acc[attr.name] = attr.value;
            return acc;
          },
          {} as Record<string, string>,
        );
        output.push(node.nodeName.toLowerCase());
        output.push(attributes);
        output.push(...convert(node.childNodes));
      }
    }
    return output;
  };

  const nodes = convert(collection) as DOMOutputSpec[];
  return nodes;
}
